/**
 * Conditional Access Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EndpointAgentModel { 
    id?: string | null;
    organizationId?: number;
    machineName?: string | null;
    osPlatform?: string | null;
    os?: string | null;
    osVersion?: string | null;
    domainName?: string | null;
    ipAddresses?: Array<string> | null;
}

